import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { MatIconRegistry, MatSnackBar } from '@angular/material';
import { ActivityItem, PatientActivity } from '../../models/patient-activity';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';


@Component({
  selector: 'app-myactivity-view',
  templateUrl: './portal-myactivity-view.component.html',
  styleUrls: ['./portal-myactivity-view.component.css'],
  animations: [
    trigger('itemState', [
      state('false', style({
        transform: 'scale(1.004)'
      })),
      state('true', style({
        transform: 'scale(1)'
      })),
      transition('false => true', animate('100ms ease-in')),
      transition('true => false', animate('100ms ease-out'))
    ])
  ]
})
export class PortalMyActivityViewComponent implements OnInit {

  private patient: any;
  private patientActivity: PatientActivity;
  private patientActivityItems: ActivityItem[];
  private patientActivityStack: any[] = [];
  private patientQuestionnaireResult: any;
  loaded: boolean;
  error: boolean
  private sectionLoaded: boolean;
  private selectedIndexStack: any[] = [];
  private selectedSection: String;
  private rgbStartIndex: number = 99;
  private rgbIndex: number = this.rgbStartIndex;


  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private patientData: PatientDataService,
    iconRegistry: MatIconRegistry, private snackBar: MatSnackBar, private loggingService: LoggingService,
    private userSession: UserSessionService) { }

  ngOnInit() {
    // Get the patient for the view
    this.getPatientData();
  }

  private getPatientData() {
    if (this.appConfigService.PatientId == null) {
      this.loaded = true;
      return;
    }

    this.patientData.getPatient(this.appConfigService.PatientId).subscribe((response => {
      this.patient = response.json();

      if (this.patient.CurrentPregnancy == null) {
        this.loaded = true;
        return;
      }

      this.patientData.getActivity(this.patient.CurrentPregnancy.PregnancyId).subscribe(response => {
        this.patientActivity = response.json();
        this.patientActivityItems = this.patientActivity.ActivityItem.ActivityItems;
        this.loaded = true;
        this.sectionLoaded = true;

      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    }), (error: HttpErrorResponse) => {
      this.handleError(error);
    });
  }

  itemClicked(item: ActivityItem) {

    // Update content flags
    item.ShowLoad = true;
    item.Current = true;

    // Flip the expand / contract marker on the folder item when clicked
    if (item.ShowItem) {
      item.ShowItem = false;
    }
    else {
      item.ShowItem = true;
    }

    // Fetch child items and any questionnaire data if required
    if (item.ActivityItems.length > 0) {
      if (item.InstanceId && item.QuestionnaireId) {
        this.getQuestionnaireData(item);
        item.QuestionnaireChildren = item.ActivityItems;
        return;
      }

      this.selectedSection = item.DisplayName;
      this.assign(item);
    }
    else {
      if (item.InstanceId) {
        this.getQuestionnaireData(item);
      }
    }
  }

  // Reassigns references so we can drill down into the content
  assign(item: ActivityItem) {



    this.patientQuestionnaireResult = null;
    let activityHistory = { ActivityItems: this.patientActivityItems, Name: item.DisplayName, LastItem: false };
    this.patientActivityStack.push(activityHistory);
    this.patientActivityItems = item.ActivityItems;
    this.rgbIndex = 99;

    this.SetLastItem();

  }

  private SetLastItem() {
    this.patientActivityStack.forEach(x => x.LastItem = false);
    if (this.patientActivityStack.length > 0) {
      this.patientActivityStack[this.patientActivityStack.length - 1].LastItem = true;
      return;
    }

  }

  // Get the required questionnaire data for the selected item
  getQuestionnaireData(item: any) {

    // If we already have the data, just return
    if (item.QuestionnaireResult) {
      item.loaded = true;
      item.ShowLoad = false;
      return;
    }

    // Get any associated questionnaireData
    if (item.QuestionnaireId != null && item.InstanceId != null) {
      this.sectionLoaded = false;
      this.patientData.getQuestionnaireResult(item.QuestionnaireId, item.InstanceId).subscribe(result => {
        this.patientQuestionnaireResult = result.json();
        this.sectionLoaded = true;
        item.QuestionnaireResult = this.patientQuestionnaireResult;
        item.Loaded = true;
        item.ShowLoad = false;
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      })
    }
  }

  // Go back to the previous content
  tabBack() {
    if (this.patientActivityStack.length > 0) {
      this.patientQuestionnaireResult = null;
      let historyItem = this.patientActivityStack.pop();
      this.patientActivityItems = historyItem.ActivityItems;
    }
  }

  goBack(activityItems: any) {

    // Find the existing item in the stack
    let foundIndex = this.patientActivityStack.findIndex(x => x.Name == this.patientActivityStack[this.patientActivityStack.length - 1].Name);

    // Assign this item items
    this.patientActivityItems = this.patientActivityStack[foundIndex].ActivityItems;

    // Remove this item from the stack by splicing it
    this.patientActivityStack.splice(foundIndex, this.patientActivityStack.length);

    this.SetLastItem();

  }

  goTop() {

    if (this.patientActivityStack[0] == undefined) {
      return;
    }

    this.patientActivityItems = this.patientActivityStack[0].ActivityItems;
    this.patientActivityStack.splice(0, this.patientActivityStack.length);
  }

  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. You appear to be offline.", "", { duration: 5000 });
        this.loggingService.log("Error - offline", this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Your login has expired.", "", { duration: 5000 });
        this.loggingService.log("Error - login expired", this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Server error.", "", { duration: 5000 });
        this.loggingService.log("Error - Server error", this.appConfigService.LogToConsole);
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-myactivity-view/portal-myactivity-view.component.ts